/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Delete_ButtonInputs */

const en_snapshot_history_delete_button = /** @type {(inputs: Snapshot_History_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Commit`)
};

const fr_snapshot_history_delete_button = /** @type {(inputs: Snapshot_History_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le commit`)
};

const de_snapshot_history_delete_button = /** @type {(inputs: Snapshot_History_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschen Commit`)
};

const it_snapshot_history_delete_button = /** @type {(inputs: Snapshot_History_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina commit`)
};

const ru_snapshot_history_delete_button = /** @type {(inputs: Snapshot_History_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить Коммит`)
};

const es_snapshot_history_delete_button = /** @type {(inputs: Snapshot_History_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar confirmación`)
};

const zh_cn2_snapshot_history_delete_button = /** @type {(inputs: Snapshot_History_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除提交`)
};

const ja_snapshot_history_delete_button = /** @type {(inputs: Snapshot_History_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除コミット`)
};

const hi_snapshot_history_delete_button = /** @type {(inputs: Snapshot_History_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कमिट हटाएं`)
};

const pt_pt2_snapshot_history_delete_button = /** @type {(inputs: Snapshot_History_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir Confirmação`)
};

/**
* | output |
* | --- |
* | "Delete Commit" |
*
* @param {Snapshot_History_Delete_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_delete_button = /** @type {((inputs?: Snapshot_History_Delete_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Delete_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snapshot_history_delete_button(inputs)
	if (locale === "de") return de_snapshot_history_delete_button(inputs)
	if (locale === "it") return it_snapshot_history_delete_button(inputs)
	if (locale === "ru") return ru_snapshot_history_delete_button(inputs)
	if (locale === "es") return es_snapshot_history_delete_button(inputs)
	if (locale === "zh-CN") return zh_cn2_snapshot_history_delete_button(inputs)
	if (locale === "ja") return ja_snapshot_history_delete_button(inputs)
	if (locale === "hi") return hi_snapshot_history_delete_button(inputs)
	if (locale === "pt-PT") return pt_pt2_snapshot_history_delete_button(inputs)
	return en_snapshot_history_delete_button(inputs)
});